import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import CheckoutStepAddress from '@/b2c/checkout/ui/CheckoutStepAddress.vue';
import CheckoutStepDeliverables from '@/b2c/checkout/ui/CheckoutStepDeliverables.vue';
import { useCheckout } from '@/b2c/checkout/useCheckout';
import CheckoutPaymentReady from '@/b2c/checkout/ui/payment/CheckoutPaymentReady.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutSteps',
  setup(__props) {

const { basket } = useCheckout();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ol", null, [
    _createVNode(CheckoutStepAddress, { class: "mb-x8" }),
    (_unref(basket).deliverables.length)
      ? (_openBlock(), _createBlock(CheckoutStepDeliverables, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(CheckoutPaymentReady)
  ]))
}
}

})